module.exports = __webpack_public_path__ + "img/electric-mining-drill-E-patch.7dc1e068.png";